import styled from "styled-components";


export const Container = styled.div`
    display: flex;
    height: 100%;
    flex-direction: column;
`;

export const Filters = styled.div`
    background-color: white;
    display: flex;
    min-height: 60px;
    justify-content: space-between;
    align-items: center;
    padding: 0px 20px;
    border-radius: 30px;
    flex-wrap: wrap;
`;

export const SectionLeft = styled.div`
    display: flex;
    margin: 10px 0px;
`;

export const SectionRight = styled.div`
    display: flex;
    align-items: center;
    margin: 10px 0px;
`;

export const Search = styled.div`
    background-color: #FBF9F6;
    display: flex;
    height: 40px;
    //border: 1px solid gray;
    border-radius: 20px;
    padding: 10px;
    align-items: center;

    input{
        display: flex;
        height: 100%;
        width: 250px;
        outline: none;
        border: none;
        background-color: transparent;
    }
`;

export const Check = styled.div`
    display: flex;
    margin-right: 20px;
    align-items: center;
    color: gray;
    span{
        display: flex;
        width: 20px;
        height: 20px;
        background-color: #FBF9F6;
        justify-content: center;
        align-items: center;
        border: 2px solid gray;
        margin-right: 5px ;
        border-radius: 4px;
    }
`;

export const DropDown = styled.div`
    display: flex;
    background-color: orange;

    span{
        display: none;
        flex-direction: column;
    }
`;


export const ContainerYampi = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    width: 100%;
    flex-direction: column;
`;

export const ContainerYampiBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    //gap: 20px;
`;

export const ItemIntegrtion= styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    
    border-radius: 50%;

    img{
        width: 150px;
        height: 150px;
        object-fit: cover;
    }
`;

export const ItemIcons= styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    width: 50px;
    flex-direction: column;


`;

